module.exports = __webpack_public_path__ + "media/images/3-2903aa171825c7b3504d0755e9cfc86c.jpg";